import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'

import { ErrorDeLaApi } from './api/nucleo'
import { App } from './App'
import { cargarMarca } from './marca/marca'
// Las fuentes de la marca, servidas por nosotros: el panel no pide nada a terceros.
import '@fontsource-variable/sora'
import '@fontsource-variable/inter'
import './estilos.css'

/**
 * Reintentar lo que el servidor ya ha contestado —«no existe», «no tienes permiso»,
 * «no hay saldo»— no cambia la respuesta y solo retrasa el mensaje. Se reintenta lo
 * que puede ser un tropiezo de la red: los 5xx y lo que ni siquiera llegó.
 */
const clienteDeConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (intentos, error) =>
        intentos < 2 && !(error instanceof ErrorDeLaApi && error.status < 500),
    },
  },
})

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('Falta el elemento raíz del panel.')

// La marca primero: en el panel de una agencia no debe asomar la de Wixy ni un instante.
void cargarMarca().then(() =>
  createRoot(raiz).render(
    <StrictMode>
      <QueryClientProvider client={clienteDeConsultas}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  ),
)
